import apiClient from './apiClient';

export const getUserSettings = async () => {
  const response = await apiClient.get('/user/settings');
  return response.data?.settings || {};
};

export const updateUserSettings = async (settings) => {
  const response = await apiClient.put('/user/settings', { settings });
  return response.data?.settings || {};
};

export const deleteUserSetting = async (settingKey) => {
  const response = await apiClient.delete(`/user/settings/${encodeURIComponent(settingKey)}`);
  return response.data?.settings || {};
};

// Telegram bot token — dedicated endpoint that validates the token
// against Telegram's getMe before persisting. Returns the cached bot
// identity { id, username, name, linkedAt } so the UI can render
// "linked to @YourBot" without ever holding the token client-side.
export const setTelegramBotToken = async (token) => {
  const response = await apiClient.put('/user/settings/telegram-bot', { token });
  return response.data?.bot || null;
};

export const deleteTelegramBotToken = async () => {
  await apiClient.delete('/user/settings/telegram-bot');
};

// Pulls the chats the user's bot has recently received messages from.
// Powers the "Find chats" picker in the subscription form so users
// don't have to hand-copy a numeric chat id from a third-party helper
// bot. Backend reads getUpdates against the user's bot token and dedups.
// Empty list is the normal "user hasn't messaged the bot in 24h" state.
export const getTelegramBotChats = async () => {
  const response = await apiClient.get('/user/settings/telegram-bot/chats');
  return response.data?.chats || [];
};
